import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { House, Key, TrendingUp, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Buyer Representation",
  description: "Guiding you from initial consultation to closing with deep local market knowledge and personalized property matches.",
  icon: House,
  link: "/ReachOutPage",
  titleClassName: "p-3 rounded-full bg-secondary/10 !w-[230px] !h-[560px] !bg-[url(https://findahomewithchris.com/wp-content/uploads/2026/03/buyer-rep.png)]"
}, {
  title: "Seller Representation",
  description: "Expert sales strategies and tough negotiations designed to secure the highest possible market price for your property.",
  icon: Key,
  link: "/ReachOutPage"
}, {
  title: "Investment Guidance",
  description: "Expert advice for investors seeking reliable opportunities and wealth building in the Hudson Valley real estate market.",
  icon: TrendingUp,
  link: "/ReachOutPage"
}];
export default function YourPathHome() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}